import { ManagementPlanModel } from "../models/completionConstDoc/EnviManageStateModel";

export const EnvironmentalItemData: ManagementPlanModel = {
  usageStateItems: [
    {
      itemName: "비산먼지방지시설",
      totalPrice: 0,
      usageItems: [
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
      ],
    },
    {
      itemName: "소음진동방지시설",
      totalPrice: 0,
      usageItems: [
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
      ],
    },
    {
      itemName: "폐기물처리시설",
      totalPrice: 0,
      usageItems: [
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
      ],
    },
    {
      itemName: "수질오염방지시설",
      totalPrice: 0,
      usageItems: [
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
      ],
    },
    {
      itemName: "기타방지시설",
      totalPrice: 0,
      usageItems: [
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
        {
          usageDate: "",
          usageItemPrice: 0,
          productName: "",
          productNum: 0,
          productPrice: 0,
          commaProductPrice: "",
          calPrice: 0,
        },
      ],
    },
  ],
};
